import { render, staticRenderFns } from "./BackgroundBlurDetail.vue?vue&type=template&id=e2f22c28&scoped=true"
import script from "./BackgroundBlurDetail.vue?vue&type=script&lang=js"
export * from "./BackgroundBlurDetail.vue?vue&type=script&lang=js"
import style0 from "./BackgroundBlurDetail.vue?vue&type=style&index=0&id=e2f22c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f22c28",
  null
  
)

export default component.exports